import { render, staticRenderFns } from "./WoBaseModal.vue?vue&type=template&id=8f39b8ae&scoped=true&"
import script from "./WoBaseModal.vue?vue&type=script&lang=ts&"
export * from "./WoBaseModal.vue?vue&type=script&lang=ts&"
import style0 from "./WoBaseModal.vue?vue&type=style&index=0&id=8f39b8ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f39b8ae",
  null
  
)

export default component.exports